// src/components/ui/LoadingSpinner.tsx
import React from 'react';

export default function LoadingSpinner() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-white via-orange-50 to-orange-100">
      <div className="text-center">
        <div className="relative">
          {/* Outer spinning ring */}
          <div className="w-16 h-16 border-4 border-orange-200 rounded-full animate-spin border-t-orange-500 mx-auto mb-4"></div>
          
          {/* Inner spinning ring */}
          <div className="absolute top-2 left-1/2 transform -translate-x-1/2 w-8 h-8 border-2 border-orange-300 rounded-full animate-spin border-t-orange-600"></div>
        </div>
        
        <div className="space-y-2">
          <h3 className="text-lg font-semibold text-gray-800">
            <span className="gradient-text">EarnBackHub</span>
          </h3>
          <p className="text-gray-600 loading-dots">Yükleniyor</p>
        </div>
      </div>
    </div>
  );
}